import React, { Component, Fragment, useEffect } from 'react';
import MaskedInput from 'react-text-mask';
const MasksInput = (props) => {
    const { inputRef, ...other } = props;


    return (
        <Fragment>
            <MaskedInput
            
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/,' ', ' ',' ','X', ' ', ' ',' ',/\d/, /\d/, /\d/, /\d/,' ', ' ',' ','X',' ', ' ',' ', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
      keepCharPositions
    />

        </Fragment>

    );
}

export default MasksInput;
